var tab_controller = {
    set_background: function(dom){
        var $this = jQuery(dom);
        var $parent = $this.closest('.wrapper.flex .flex-inner');
        var $active = $parent.find('.tab.active');
        var $initial = $parent.find('.tab.initial');
        var $bg = $active.find('.tab-bg-container');
        if($active.length > 0){
            var $current_bg = $parent.find('.parent-bg');
            // console.log('Current BG',$current_bg);
            $current_bg.remove();
            var $bg_clone = $bg.clone();
            $bg_clone.addClass('parent-bg');
            $parent.append($bg_clone);
        }
        if ($initial.length > 0){
            var $current_bg = $parent.find('.parent-bg');
            $current_bg.remove();
            var $bg_clone = $initial.find('.tab-bg-container').clone();
            $bg_clone.addClass('parent-bg');
            $parent.append($bg_clone);
        }
    },
    bind: function(){
        jQuery('.tab-control').click(function(){
            $parent = jQuery(this).closest('.tabbed-container');
            $tabs = $parent.find('.tab-content');
            $tabs.find('.initial').removeClass('initial');
            $this = jQuery(this);
            if(!$this.hasClass('active')){
                var tab_to_activate = $this.data('for');
                $parent.find('.tab-control').removeClass('active');
                $tabs.find('.tab').removeClass('active');
                $this.addClass('active');
                $to_activate = $tabs.find('.tab[data-is="'+tab_to_activate+'"]')
                $to_activate.addClass('active');
                if(jQuery(window).width() < 768
                    && $to_activate.offset().top - 200 > jQuery(window).scrollTop() + (jQuery(window).height() / 2)
                ){
                    jQuery('html, body').animate({
                        scrollTop: ($to_activate.offset().top - 200)
                    }, 500);
                }
                tab_controller.set_background(this);
            }
        });

        var tabs = jQuery('.tab-control');
        var active_tab = jQuery('.tab.active');
        var initial_tab = jQuery('.tab.initial');

        // hotfix for live coolsync cta
        var $pitw = jQuery('.pitw-wrapper');

        if ($pitw.length > 0){
            jQuery(jQuery('.tab-control')[0]).remove();
        }

        if(tabs.length > 0){
            tabs.each(function(){
                $parent = jQuery(this).closest('.tabbed-container');
                $tabs = $parent.find('.tab-content');
                $this = jQuery(this);
                $active_tab = $this.find('.tab-control.active');
            });
        }
        if(active_tab.length > 0){
            tab_controller.set_background(active_tab);
        }
        if(initial_tab.length > 0){
            tab_controller.set_background(initial_tab);
            initial_tab.addClass('active');
        }
    }
};

jQuery(document).ready(function(){
    tab_controller.bind();

    jQuery('.mobile-tab-control').on('click', function() {
        console.log('Mobile Tab Control Clicked');
        var $parent = jQuery(this).closest('.flex-inner');
        var $tabs = $parent.find('.tab-controls');
        var $this = jQuery(this);
        var $next;

        // find the tab with the active class and activate the next one
        var $active = $tabs.find('.tab-control.active');

        if ( $this.hasClass('mobile-tab-control--prev') ) {
            $next = $active.prev();
            if ($next.length === 0) {
                $next = $tabs.find('.tab-control').last();
            }
        } else {
            $next = $active.next();
            if ($next.length === 0) {
                $next = $tabs.find('.tab-control').first();
            }
        }

        $next.trigger('click');
    });
});